// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-b92pK {
  background-color: #ff7f50;
}
.debug2-DkvMP {
  background-color: #6495ed;
}
.vtsummary-RURVd {
  box-sizing: border-box;
  width: 100%;
  margin-top: 30px;
  border-radius: 20px;
  border: 2px solid #5D5D5D;
  color: #5D5D5D;
}
.vtsummary-RURVd .title-YDNks {
  font-size: 1.375em;
  padding: 8px 20px;
  font-family: "AvenirBlack";
}
.vtsummary-RURVd .specialexcursions-jgl9s {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: calc(100% - 40px);
  margin: 0px 20px;
  padding: 20px 0px;
  border-top: 2px solid #E1E1E1;
}
.vtsummary-RURVd .summary-sFB78 {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: calc(100% - 40px);
  margin: 0px 20px;
  padding: 20px 0px;
  border-top: 2px solid #E1E1E1;
  font-family: "AvenirBlack";
}
.vtsummary-RURVd .summary-sFB78 .conditions-HMh02 {
  flex: 1;
  min-width: 250px;
}
.vtsummary-RURVd .summary-sFB78 .prices-S7HyR {
  flex: 1;
  min-width: 250px;
}
.vtsummary-RURVd .summary-sFB78 .prices-S7HyR .pricestitle-S9KsJ {
  font-size: 1.125em;
}
.vtsummary-RURVd .summary-sFB78 .prices-S7HyR .price-Jvr6b {
  display: flex;
  gap: 20px;
  width: 100%;
  line-height: 25px;
  font-size: 1em;
}
.vtsummary-RURVd .summary-sFB78 .prices-S7HyR .price-Jvr6b .name-vFAAR {
  flex: 1;
}
.vtsummary-RURVd .meetingpoint-kKdOv {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: calc(100% - 40px);
  margin: 0px 20px;
  padding: 20px 0px;
  border-top: 2px solid #E1E1E1;
}
.vtsummary-RURVd .footer-RVoTQ {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  border-radius: 0px 0px 20px 20px;
  background-color: #E1E1E1;
}
.vtsummary-RURVd .footer-RVoTQ .totalcontainer-KfMTM {
  flex: 1;
  min-width: 150px;
  font-size: 1em;
  font-family: "AvenirBook";
}
.vtsummary-RURVd .footer-RVoTQ .totalcontainer-KfMTM .total-cpGiI {
  font-size: 1.375em;
  font-family: "AvenirBlack";
}
.vtsummary-RURVd .footer-RVoTQ .totalcontainer-KfMTM .tax-omXva {
  font-size: 0.875em;
}
.vtsummary-RURVd .footer-RVoTQ .buttons-taWwi {
  flex: 1;
  width: 100%;
  min-width: 350px;
  text-align: right;
}
.vtsummary-RURVd .footer-RVoTQ .buttons-taWwi .button-JdOJk {
  max-width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/components/VTForm/components/VTSummary/VTSummary.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA7BA;EAAW,sBAAA;EAAwB,WAAA;EAAa,gBAAA;EAAkB,mBAAA;EAAqB,yBAAA;EAA8B,cAAA;AAqCrH;AArCA;ECoCE,kBAAA;EDnCuB,iBAAA;EAAmB,0BAAA;AAyC5C;AA1CA;EAGqB,aAAA;EAAc,SAAA;EAAU,eAAA;EAAiB,wBAAA;EAA0B,gBAAA;EAAiB,iBAAA;EAAmB,6BAAA;AAgD5H;AAnDA;EAMW,aAAA;EAAc,SAAA;EAAU,eAAA;EAAiB,wBAAA;EAA0B,gBAAA;EAAiB,iBAAA;EAAmB,6BAAA;EAAkC,0BAAA;AAuDpJ;AA7DA;EAOgB,OAAA;EAAQ,gBAAA;AA0DxB;AAjEA;EAQY,OAAA;EAAQ,gBAAA;AA6DpB;AArEA;ECoCE,kBAAA;ADoCF;AAxEA;EAUa,aAAA;EAAc,SAAA;EAAU,WAAA;EAAa,iBAAA;EC0BhD,cAAA;AD2CF;AA/EA;EAWc,OAAA;AAuEd;AAlFA;EAiBgB,aAAA;EAAc,SAAA;EAAU,eAAA;EAAiB,wBAAA;EAA0B,gBAAA;EAAiB,iBAAA;EAAmB,6BAAA;AA0EvH;AA3FA;EAoBU,aAAA;EAAc,SAAA;EAAW,eAAA;EAAiB,mBAAA;EAAoB,sBAAA;EAAwB,WAAA;EAAa,aAAA;EAAc,gCAAA;EAAkC,yBAAA;AAkF7J;AAtGA;EAqBoB,OAAA;EAAQ,gBAAA;ECe1B,cAAA;EDf4D,yBAAA;AAuF9D;AA5GA;ECoCE,kBAAA;EDd2B,0BAAA;AA0F7B;AAhHA;ECoCE,kBAAA;AD+EF;AAnHA;EAyBa,OAAA;EAAQ,WAAA;EAAY,gBAAA;EAAkB,iBAAA;AAgGnD;AAzHA;EA0Be,gBAAA;AAkGf","sourcesContent":["@import \"../../../../assets/css/theme\";\n\n//padding:8px 20px;\n\n.vtsummary{box-sizing: border-box; width: 100%; margin-top:30px;  border-radius: 20px; border:2px solid @colorgris5; color:@colorgris5;\n  .title{.font-base(22); padding:8px 20px;  font-family:\"AvenirBlack\";}\n\n  .specialexcursions{display:flex; gap:20px; flex-wrap: wrap; width: calc(100% - 40px); margin:0px 20px; padding: 20px 0px; border-top:2px solid @colorgris1;\n\n  }\n  .summary{display:flex; gap:20px; flex-wrap: wrap; width: calc(100% - 40px); margin:0px 20px; padding: 20px 0px; border-top:2px solid @colorgris1; font-family:\"AvenirBlack\";\n    .conditions{flex:1; min-width: 250px;}\n    .prices{flex:1; min-width: 250px;\n      .pricestitle{.font-base(18); }\n      .price{display:flex; gap:20px; width: 100%; line-height: 25px; .font-base(16);\n        .name{flex:1;}\n        .total{}\n      }\n    }\n  }\n\n  .meetingpoint{display:flex; gap:20px; flex-wrap: wrap; width: calc(100% - 40px); margin:0px 20px; padding: 20px 0px; border-top:2px solid @colorgris1;\n  }\n\n  .footer{display:flex; gap: 20px; flex-wrap: wrap; align-items:center; box-sizing: border-box; width: 100%; padding:20px; border-radius: 0px 0px 20px 20px; background-color: @colorgris1;\n    .totalcontainer{flex:1; min-width: 150px; .font-base(16); font-family:\"AvenirBook\";\n      .total{.font-base(22); font-family:\"AvenirBlack\";}\n      .tax{.font-base(14);}\n    }\n    .buttons{flex:1; width:100%; min-width: 350px; text-align: right;\n      .button{ max-width:200px; }\n    }\n  }\n\n}","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-b92pK`,
	"debug2": `debug2-DkvMP`,
	"vtsummary": `vtsummary-RURVd`,
	"title": `title-YDNks`,
	"specialexcursions": `specialexcursions-jgl9s`,
	"summary": `summary-sFB78`,
	"conditions": `conditions-HMh02`,
	"prices": `prices-S7HyR`,
	"pricestitle": `pricestitle-S9KsJ`,
	"price": `price-Jvr6b`,
	"name": `name-vFAAR`,
	"meetingpoint": `meetingpoint-kKdOv`,
	"footer": `footer-RVoTQ`,
	"totalcontainer": `totalcontainer-KfMTM`,
	"total": `total-cpGiI`,
	"tax": `tax-omXva`,
	"buttons": `buttons-taWwi`,
	"button": `button-JdOJk`
};
export default ___CSS_LOADER_EXPORT___;
